import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'resto-unauth-header',
  imports: [TranslocoPipe],
  templateUrl: './unauth-header.component.html',
  styleUrl: './unauth-header.component.scss',
})
export class UnauthHeaderComponent {}
